import axios from "axios";
import DriversType from "../../../types/DriversType";
import { ServerSideTypes } from "../../common/OperationCommonTypes";
import { MissingEquipmentTypes } from "../Types";


const MissingEquipmentServer ={
    get:{
        getAllEquipment:(tenant:string,data:MissingEquipmentTypes.MissingEquipmentFilter,serverParams: ServerSideTypes.IParams)=>{
         return axios.get<ServerSideTypes.IResult<any>>("./masterdatadamage/equipments/byfilters",{params:{tenant,...data,...serverParams}}).then(
            response => response.data,
            )
          },
          getEquipment:(tenant:string)=>{
            return axios.get<any>("./masterdatadamage/damageform/geteqlist", {params:{tenants:tenant}}).then(response =>response.data)
          },
          export:(tenant:string,data:any)=>{
            return axios.get("./masterdatadamage/equipments/exportexcel",{params:{tenant,...data},responseType:"arraybuffer"});
          }
        },
    }

export default MissingEquipmentServer;